import { RadioGroup, Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import { setIsPublishedAtCustomAction } from "../investorCommunicationEditState";
import InvestorCommunicationPublishDateField from "./InvestorCommunicationPublishDateField";
import InvestorCommunicationPublishDateOption from "./InvestorCommunicationPublishDateOption";

const InvestorCommunicationTimingTab = () => {
  const { investorCommunication, state, setState, hasEditPermissions, isSaving } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  const { status, publishedToLiveAt, isPublishedAtCustom } = investorCommunication;
  const isDraft = status === "Draft";
  const isEditingDisabled = !hasEditPermissions || isSaving || isDraft;
  const isMakeLiveLocked = status === "Live" && isPublishedAtCustom;
  const selectedOption = state.isPublishedAtCustom ? "custom" : "make_live";
  const madeLiveAt = state.isPublishedAtCustom ? undefined : publishedToLiveAt;

  return (
    <Stack spacing={2} sx={{ flex: 1, pt: 2.5, pb: 2 }}>
      <Stack spacing={0.5}>
        <Typography variant="subtitle1">Publish Date</Typography>
        {isDraft && (
          <Typography variant="caption" color="textSecondary">
            Can be set once the communication is published to Preview.
          </Typography>
        )}
      </Stack>

      <Stack spacing={1} sx={{ width: "50%" }}>
        <RadioGroup
          value={selectedOption}
          sx={{ rowGap: 1 }}
          onChange={(_, value) => setState(setIsPublishedAtCustomAction(value === "custom"))}
        >
          <InvestorCommunicationPublishDateOption
            value="make_live"
            selectedValue={selectedOption}
            title={madeLiveAt ? `Make Live • ${convertISODateTime(madeLiveAt)}` : "Make Live"}
            description="The date and time it becomes visible to investors"
            disabled={isEditingDisabled || isMakeLiveLocked}
            disabledTooltip={
              isMakeLiveLocked
                ? "A Live communication keeps its custom date. Unpublish it to Preview first."
                : undefined
            }
          />
          <InvestorCommunicationPublishDateOption
            value="custom"
            selectedValue={selectedOption}
            title="Custom date"
            description="A date and time you choose, kept when the communication is published again"
            disabled={isEditingDisabled}
          />
        </RadioGroup>

        {state.isPublishedAtCustom && <InvestorCommunicationPublishDateField />}
      </Stack>
    </Stack>
  );
};

export default InvestorCommunicationTimingTab;
